var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0499 11.0002H5.90994L7.20994 9.71019C7.39824 9.52188 7.50403 9.26649 7.50403 9.00019C7.50403 8.73388 7.39824 8.47849 7.20994 8.29019C7.02164 8.10188 6.76624 7.99609 6.49994 7.99609C6.23364 7.99609 5.97824 8.10188 5.78994 8.29019L2.78994 11.2902C2.69621 11.3831 2.62182 11.4937 2.57105 11.6156C2.52028 11.7375 2.49414 11.8682 2.49414 12.0002C2.49414 12.1322 2.52028 12.2629 2.57105 12.3848C2.62182 12.5066 2.69621 12.6172 2.78994 12.7102L5.78994 15.7102C5.8829 15.8039 5.9935 15.8783 6.11536 15.9291C6.23722 15.9798 6.36793 16.006 6.49994 16.006C6.63195 16.006 6.76266 15.9798 6.88452 15.9291C7.00638 15.8783 7.11698 15.8039 7.20994 15.7102C7.30367 15.6172 7.37806 15.5066 7.42883 15.3848C7.4796 15.2629 7.50574 15.1322 7.50574 15.0002C7.50574 14.8682 7.4796 14.7375 7.42883 14.6156C7.37806 14.4937 7.30367 14.3831 7.20994 14.2902L5.90994 13.0002H20.0499C20.298 12.9881 20.5326 12.8841 20.7082 12.7085C20.8838 12.5329 20.9878 12.2982 20.9999 12.0502V12.0002C21.0003 11.7434 20.9018 11.4963 20.7249 11.3102C20.5481 11.124 20.3064 11.013 20.0499 11.0002V11.0002Z",
    fill: "#202A3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 17H3.95C3.42533 17 3 17.4253 3 17.95V18.05C3 18.5747 3.42533 19 3.95 19H20.05C20.5747 19 21 18.5747 21 18.05V17.95C21 17.4253 20.5747 17 20.05 17Z",
    fill: "#202A3F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.05 5H3.95C3.42533 5 3 5.42533 3 5.95V6.05C3 6.57467 3.42533 7 3.95 7H20.05C20.5747 7 21 6.57467 21 6.05V5.95C21 5.42533 20.5747 5 20.05 5Z",
    fill: "#202A3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrow);
export default __webpack_public_path__ + "static/media/menuArrow.62d599060710d26a678514d2d01ef061.svg";
export { ForwardRef as ReactComponent };